// removed by extract-text-webpack-plugin
module.exports = {"FlashModal":"FlashEmailModal__-loca-__1VySy","Text":"FlashEmailModal__-loca-__2qmRD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Modal/FlashEmailModal/FlashEmailModal.css
// module id = 218
// module chunks = 0